var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pix-signalr-manager" }, [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isSignalrOnline,
          expression: "isSignalrOnline",
        },
      ],
      staticClass: "pix-signalr-manager-status_online",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }